import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: 'nav',
  name: '宫格导航',
  icon: '宫',
  group: '导航组件',
  description: '以宫格展示一组导航入口',
  aliases: ['quick-entry', 'tool-grid', 'home-grid'],
  defaultProps: {
    columns: 4,
    items: []
  }
}
